import useLocationContext from '$src/hooks/useLocationContext';
import OnboardingContainer from '$src/components/OnboardingContainer';
import { redirectToOnboardingHowVSGWorks } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import { HOW_TO_USE_MOTION_ZONES_URL, CREATING_PRIVACY_ZONES_URL } from '$src/constants/urls';
import useStores from '$src/hooks/useStores';
import aboutImage from '$src/assets/img/onboardingAbout.png';
import { Cell } from '@amzn/ring-react-components/csr/components/Cell';
import { TwofaIcon, ChimeSnoozeOffIcon, MotionZonesIcon, AudioVideoPrivacyIcon } from '@ring-icons';

import './EventsAndPrivacy.less';

function EventsAndPrivacy() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      headerTitle="Setup Complete"
      icon={TwofaIcon}
      className="events-and-privacy"
      title="Tips for managing event usage and privacy."
      primaryText="Go To Ring Dashboard"
      image={aboutImage}
      handleClose={() => handleBackToRingDashboard(isMobile)}
      handleBack={() => redirectToOnboardingHowVSGWorks(locationId)}
      primaryActionHandler={() => handleBackToRingDashboard(isMobile)}
    >
      <Cell image={<ChimeSnoozeOffIcon />} title={<b>Snooze Monitoring</b>}>
        If your enrolled cameras are experiencing heavy amounts of activity or you want to conserve your event budget, you can pause Virtual Security
        Guard monitoring without disarming your Alarm by snoozing a single device or an entire location in the Ring App.
      </Cell>
      <Cell image={<MotionZonesIcon />} title={<b> Adjust your Motion Zones</b>}>
        {
          <p>
            Virtual Guards monitor your enrolled devices when the service is active and a person is detected, and each event counts toward your
            monthly event budget. We recommend adjusting Motion Settings for each device in the Ring App so you can exclude areas you don’t want
            agents to monitor, such as a busy street or sidewalk. To learn more about setting up Motion Zones,
            <a href={HOW_TO_USE_MOTION_ZONES_URL} target="_blank" rel="noreferrer">
              {' '}
              click here.
            </a>
          </p>
        }{' '}
      </Cell>

      <Cell image={<AudioVideoPrivacyIcon />} title={<b> Check your Privacy Zones</b>}>
        <p>
          This feature is available in the Ring App and prevents agents from viewing areas on your property you consider private. Areas covered by
          Privacy Zones can’t be recorded or monitored for motion. To learn more about setting up Privacy Zones,
          <a href={CREATING_PRIVACY_ZONES_URL} target="_blank" rel="noreferrer">
            {' '}
            click here.
          </a>
        </p>
      </Cell>
    </OnboardingContainer>
  );
}

export default EventsAndPrivacy;
